import styles from "../../styles/PLMApp.module.css";
// src/components/plm/AnimatedCategoryBar.jsx

import { useSpring, animated, config } from "@react-spring/web";

export default function AnimatedCategoryBar({ pct, color }) {
  const spring = useSpring({
    from: { width: "0%" },
    to: { width: `${pct}%` },
    delay: 400,
    config: config.gentle,
  });

  return (
    <div className={styles.sideProgressBarTrack}>
      <animated.div
        style={{
          ...spring,
          height: "100%",
          borderRadius: 2,
          background: `linear-gradient(to right, ${color}, ${color}cc)`,
        }}
      />
    </div>
  );
}
